module.exports = __webpack_public_path__ + "static/media/5.f5825443.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/5.mp3
// module id = 56
// module chunks = 0